import SalonBusinessCpaTopicWorkspace from "./SalonBusinessCpaTopicWorkspace";

export default function SalonBusinessCpaBookkeeping() {
  return <SalonBusinessCpaTopicWorkspace topicKey="bookkeeping" />;
}
